// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__3eSmW","calendarButtons":"ClockData_calendarButtons__pOBAL"};